// try to preload fonts and images, render app when loaded, if it fails, render app without it
import FontFaceObserver from 'fontfaceobserver'
import ImagePreloader from 'image-preloader'
import { path, pathOr } from 'ramda'
import * as Helpers from './helpers/index'

const getImageList = () => {
  // eslint-disable-next-line
  const data = window.__initialData__ && JSON.parse(window.__initialData__)
  const isDesktop = window.innerWidth >= 768
  const works = pathOr([], ['works'], data).filter(w => path(['images', 0, 'width'], w))

  const images = works.map((w) => {
    const name = isDesktop
      ? w.images[0].original
      : w.images[0].thumbs[1].name
    const prefix = isDesktop
      ? Helpers.getImageUrlPrefix('work-posters')
      : Helpers.getThumbUrlPrefix('work-posters')

    return prefix + name
  })

  const thumbs = isDesktop
    ? works.map((w) => {
      const prefix = Helpers.getThumbUrlPrefix('work-posters')
      return prefix + w.images[0].thumbs[0].name
    })
    : []

  images.length = isDesktop ? 1 : 2
  const allImages = [...images, ...thumbs]

  const promises = allImages.map(i => ImagePreloader.simplePreload(i))
  return promises
}

const preloadFonts = (render) => {
  // preload fonts
  const nitti = new FontFaceObserver('NittiLight').load()
  const grotesk = new FontFaceObserver('NittiGroteskMedium').load()

  // render anyway if promise fails
  nitti.catch(() => render())
  grotesk.catch(() => render())

  Promise.all([nitti, grotesk]).then(render).catch(render)
}

export default (render) => {
  const imageList = getImageList()

  Promise.all(imageList)
    .then(() => {
      preloadFonts(render)
    })
    .catch(() => {
      preloadFonts(render)
    })
}




// WEBPACK FOOTER //
// ./src/preload.js